import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { defaultStartDate } from 'constants/suspensionConstants';
import { Controller } from 'react-hook-form';
import SuspensionDatePicker from './SuspensionDatePicker';

const styles = (theme) => ({
  Container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0 0 24px 0',
    '& >div': {
      width: '48%',
    },
    '& input': {
      cursor: 'pointer',
    },
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiInputAdornment-root': {
      color: theme.palette.xpl.secondary.default,
    },
    //The size of ripple of clear button
    '& .MuiIconButton-root,.MuiTouchRipple-root,.MuiIconButton-root:hover': {
      height: '39px',
      width: '39px',
    },
  },
  Highlight: {
    '& .MuiInputBase-root': {
      borderColor: theme.palette.xpl.secondary.default,
    },
  },
});
const SuspensionDateRangePicker = (props) => {
  const {
    classes,
    control,
    setValue,
    localisation,
    getValues,
    errors,
    disableStartDate,
    canChargeForSuspension,
    minEndDate,
    maxEndDate,
    handleSelectStartDate,
    allowedSuspensionPeriod,
  } = props;

  const dateDisplayFormat = localisation.locales.dateFormat;
  const [highlightEndDate, setHighlightEndDate] = useState(false);

  // This variable is used to control the end date.
  // The end date calendar will be restricted from displaying all dates when the following conditions are simultaneously met:
  // 1. User cannot charge against suspension rule.
  // 2. allowedSuspensionPeriod of the suspension rule is configured.
  const isEndDateCalendarRestricted =
    !canChargeForSuspension && allowedSuspensionPeriod !== null;

  return (
    <div className={classes.Container}>
      <div>
        <Controller
          name={'suspensionStartDate'}
          rules={{
            required: 'This field is required',
          }}
          control={control}
          render={({ onChange, value }) => (
            <SuspensionDatePicker
              value={value}
              placeholder={dateDisplayFormat}
              error={
                errors.suspensionStartDate && errors.suspensionStartDate.message
              }
              onChange={(e) => {
                onChange(e);
                if (getValues('suspensionEndDate') !== null) {
                  setValue('suspensionEndDate', null);
                  setHighlightEndDate(true);
                }
              }}
              onAccept={handleSelectStartDate}
              format={dateDisplayFormat}
              label="Start Date"
              minDate={defaultStartDate}
              /*Only in Edit page, the start date can be disabled when the existing start date is less than today*/
              disabled={disableStartDate}
            />
          )}
        />
      </div>
      <div>
        <Controller
          name={'suspensionEndDate'}
          control={control}
          rules={{
            required: isEndDateCalendarRestricted && 'This field is required',
          }}
          render={({ onChange, value }) => (
            <SuspensionDatePicker
              value={value}
              className={highlightEndDate ? classes.Highlight : ''}
              placeholder={dateDisplayFormat}
              onChange={(e) => {
                onChange(e);
                setHighlightEndDate(false);
              }}
              format={dateDisplayFormat}
              error={
                errors.suspensionEndDate && errors.suspensionEndDate.message
              }
              label="End Date"
              clearDate={(e) => {
                setValue('suspensionEndDate', null);
              }}
              minDate={minEndDate}
              /*When maxDate is undefined, the datepicker will ignore this prop*/
              maxDate={isEndDateCalendarRestricted ? maxEndDate : undefined}
            />
          )}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(SuspensionDateRangePicker);
